import {
  form,
  Form as AppForm,
  FormInput,
  FormRow
} from "MODULES/shared/components/Forms";
import { connect } from "react-redux";
import { transferRoLineItem } from "MODULES/RepairOrders/actions";
import T from "prop-types";
import React, { useState } from "react";
import { searchRepairStationCompanies } from "MODULES/companies/actions";
import SearchCompany from "MODULES/companies/shared/FindOrCreateCompanyToggle/SearchCompany";
import { searchContacts } from "MODULES/parts/actions";
import api from "APP_ROOT/api";
import { Col } from "react-bootstrap";
import { Field } from "redux-form";
import { REPAIR_STATION } from "MODULES/companies/constants";
import { DashedSeparator } from "MODULES/shared/components";
import {
  COMPANY_ID,
  CONTACT_ID,
  PAYMENT_TERMS,
  RETURN_TO_FOB,
  SHIP_TO_COMPANY_ADDRESS_ID,
  SHIP_TO_COMPANY_ID,
  SHIP_TO_FOB,
  SHIP_TO_SHIPPING_ADDRESS,
  SHIP_TO_SHIPPING_METHOD,
  SHIP_TO_TYPE
} from "APP_ROOT/constants";
import ShippingFields from "MODULES/Orders/shared/ShippingFields";
import { COMPANY, DROPSHIP } from "MODULES/PurchaseOrders/constants";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import { selectPrimaryContact } from "MODULES/companies/helpers";
import { OUTGOING_AWB_NUMBER } from "MODULES/Shipping/constants";
import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import PaymentTerms from "MODULES/shared/components/PaymentTerms/PaymentTerms";

const formName = "transferRepairForm";

function Form(props) {
  const { setFieldValue } = props;
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [addresses, setAddresses] = useState([]);

  const fetchContacts = value => {
    if (!value) {
      return null;
    }
    return searchContacts(value).then((vals = []) => {
      setContacts(vals);
      selectPrimaryContact(vals, setFieldValue(CONTACT_ID));
    });
  };

  const fetchAddresses = companyId => {
    api.companies.physicalAddresses
      .search(companyId, {
        page: 1,
        limit: 100,
        sort: "primary",
        reverse: true
      })
      .then(({ data: { results } }) => {
        if (results.length > 0) {
          const primaryAddress = results[0];
          setAddresses(results);

          setFieldValue("repair_station_physical_address_id")(
            primaryAddress.id
          );
        }
      });
  };

  const handleCompanySelected = company => {
    setSelectedCompany(company);
    setFieldValue(PAYMENT_TERMS)(company.vendor_credit_terms);
    fetchAddresses(company.id);
  };

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <SearchCompany
          companySearch={searchRepairStationCompanies}
          contacts={contacts}
          formName={formName}
          fetchContacts={fetchContacts}
          selectedCompany={selectedCompany}
          onCompanySelected={handleCompanySelected}
          type="repairOrder"
          required
        />
        <FormRow>
          <Col md={6}>
            <PaymentTerms />
          </Col>
          <Col md={6}>
            <div className="form-group">
              <Field
                name={OUTGOING_AWB_NUMBER}
                component={FormInput}
                label="AWB Number"
              />
            </div>
          </Col>
        </FormRow>
        <DashedSeparator />
        <h4>Ship To</h4>
        <FormRow>
          <Col md={6}>
            <div className="form-group">
              <Field
                name={SHIP_TO_FOB}
                component={FormInput}
                label="FOB"
                required
              />
            </div>
          </Col>
        </FormRow>
        <ShippingFields
          formName={formName}
          shippingFields={[
            SHIP_TO_TYPE,
            SHIP_TO_COMPANY_ID,
            SHIP_TO_COMPANY_ADDRESS_ID
          ]}
          setFOB={val => setFieldValue(RETURN_TO_FOB)(val)}
          repairStationOptions={addresses}
          shippingTypes={[REPAIR_STATION, COMPANY, DROPSHIP]}
          shippingMethod={SHIP_TO_SHIPPING_METHOD}
          shippingAddressField={SHIP_TO_SHIPPING_ADDRESS}
          hasLocations={false}
        />
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data =>
    dispatch(transferRoLineItem(ownProps.lineItem.id, data, ownProps.close))
}))(
  form({
    form: formName,
    validate: values =>
      validator(values, f => {
        f.validate(COMPANY_ID, CONTACT_ID).satisfies(rules.required);
      })
  })(withFieldAccessors(Form))
);

Form.propTypes = {
  approveROLineItem: T.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/Transfer/Form.jsx